import axiosConfig from "./axiosConfig";

// One saved search's frozen row set. Fetched only when a surface needs the refs
// themselves - the history list returns counts, not arrays, because every
// stored `sourceRefs` across 200 searches is an unbounded read.
export interface LeadSearchDetail {
  id: string;
  name: string;
  sourceRefs: string[];
}

const getLeadSearch = async (
  authToken: string,
  searchId: string
): Promise<LeadSearchDetail> => {
  const { data } = await axiosConfig.get(
    `/leads/searches/${encodeURIComponent(searchId)}`,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default getLeadSearch;
